var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './SchemaEditor.view.html';
import { ITimeoutService } from 'angular';
let SchemaEditorComponent = class SchemaEditorComponent {
    static $inject = ['$timeout'];
    constructor($timeout) {
        'ngInject';
        this.editorLoading = true;
        //#endregion
        this.schemaChanged = ({ code }) => {
            if (this.onSchemaChange) {
                this.onSchemaChange({ $schema: code });
            }
            else {
                console.warn('onSchemaChange callback is not provided.');
            }
        };
        this.didCreateEditor = (event) => {
            this.$timeout(() => {
                if (event && event.editor) {
                    this.editor = event.editor;
                    this.$timeout(() => {
                        this.editor.layout();
                        this.editorLoading = false;
                    }, 1000);
                    // disable minimap
                    this.editor.updateOptions({
                        minimap: {
                            enabled: false,
                        },
                    });
                }
            }, 2000);
        };
        this.$timeout = $timeout;
    }
    //#region Lifecycle Hooks
    $onInit() {
    }
};
//#endregion
//#region Constructor
SchemaEditorComponent.$inject = ['$timeout'];
SchemaEditorComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: template,
        bindings: {
            schema: '<',
            isInvalidSchema: '<',
            onSchemaChange: '&',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _a : Object])
], SchemaEditorComponent);
export { SchemaEditorComponent };
